import * as React from "react";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { OutskirtBuildingUpgrade } from "../outskirts/upgrade/OutskirtBuildingUpgrade";
export var UpgradeLibrary = function () {
    return React.createElement(OutskirtBuildingUpgrade, { type: IdOutskirtBuildings.Library });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/library/UpgradeLibrary.tsx
// module id = 2704
// module chunks = 3